import CreateIcon from "../../Icons/Create";
import loadable from '@loadable/component';
import { postApiFormData } from "../../helpers/AxiosInstance";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { useState } from "react";
import usePostHook from "../../customHooks/usePostHook";
import useGetHook from "../../customHooks/useGetHook";
const OrderBulkUploadComponent = loadable(
  () => import("../../components/Order/OrderBulkUpload")
);
const OrderBulkUpload = () => {
  const [validOrders, setValidOrders] = useState<any>([])
  const [inValidOrders, setInValidOrders] = useState<any>([])
  const [openPreviewData, setOpenPreviewData] = useState<Boolean>(false)
  const [isUploading, setIsUploading] = useState<Boolean>(false)

  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["orders"],
    navigateURL: "/order?limit=10&page=0",
  });

  const handleFileUpload = async (data: any, setError: any) => {
    if (userProfileType?.is_staff && !data?.merchant) {
      toast.error("Merchant is required")
      return
    }
    setIsUploading(true)
    const formData = new FormData()
    formData.append("file", data?.file[0])
    formData.append("merchant", data?.merchant)
    try {
      let url = `${APIS.ORDER}bulk-upload/`
      const res = await postApiFormData({ url, formData })
      if (res.status === 200) {
        console.log(res?.data)
        setValidOrders([...res?.data?.valid])
        setInValidOrders([...res?.data?.invalid])
        setOpenPreviewData(true)
        toast.success("File uploaded successfully")
      }
    } catch (e) {
      console.log(e)
      toast.success("Somethings went wrongs")
    }
    setIsUploading(false)
  }

  const handleCommitValidOrders = async () => {
    const url = `${APIS.ORDER}commit-bulk-upload/`;
    let formData = {
      valid_data: validOrders
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res.status === 200) {
        setOpenPreviewData(false)
      }
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Bulk Upload Consignment</span>
      </div>
      <OrderBulkUploadComponent
        handleFileUpload={handleFileUpload}
        validOrders={validOrders}
        inValidOrders={inValidOrders}
        openPreviewData={openPreviewData}
        setOpenPreviewData={setOpenPreviewData}
        handleCommitValidOrders={handleCommitValidOrders}
        isUploading={isPostLoading}
        userProfileType={userProfileType}
        isFileUploading={isUploading}
      />
    </>

  )
}

export default OrderBulkUpload
